import React, { useMemo } from "react";
import { useApplicationContext } from "../context/ApplicationContext";
import { DropdownSelector } from "./DropdownSelector";

/**
 * TenantSelector - Displays and allows switching between different tenant environments
 *
 */
export const TenantSelector: React.FC = () => {
  const { tenantId, tenantIds, openSwitchModal } = useApplicationContext();
  const tenantMenuOptions = useMemo(() => tenantIds || [], [tenantIds]);
  const displayTenant = sessionStorage.getItem("tenantId") || tenantId;

  return (
    <DropdownSelector
      ariaLabel="Open tenant menu"
      selectedValue={displayTenant}
      options={tenantMenuOptions}
      onSelect={(tId) => {
        if (tId !== displayTenant) {
          openSwitchModal("tenant", tId);
        }
      }}
      variant="text"
    />
  );
};
